module.exports = __webpack_public_path__ + "img/6.生活的艺术（于丹）.0a75b57d.jpg";